import { createSlice } from "@reduxjs/toolkit";
import { customerPortal } from "@vilocnv/allsetra-core";
import getIconsCases from "./cases/get-icons.cases";
import getIconsByCategoryCases from "./cases/get-icons-by-category.cases";

type IconState = customerPortal.icons.IconState;

const initialState: IconState = {
  icons: [],
  isLoadingIcons: false,
  iconsByCategory: [],
  isLoadingIconsByCategory: false
};

const iconsSlice = createSlice({
  name: "icons",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    getIconsCases(builder);
    getIconsByCategoryCases(builder);
  }
});

export default iconsSlice.reducer;
